import { ref, get } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import * as actionType from "../../../../context/actions";

const GetAssignerUserBusinessData = async (state, dispatch, memberUid, ownerIds) => {

    if (!memberUid || !ownerIds?.length) return [];

    try {

        const allBusinesses = [];

        const ownerPromises = ownerIds.map(async (ownerUid) => {

            const sharedRef = ref(
                database,
                `invoiceGenerator/users/${ownerUid}/sharedWith/${memberUid}`
            );

            const snapshot = await get(sharedRef);
            if (!snapshot.exists()) return;

            const data = snapshot.val();
            const companyIds = [...new Set(data.company || [])];

            const companies = [];

            const companyPromises = companyIds.map(async (businessId) => {

                const companyRef = ref(
                    database,
                    `invoiceGenerator/users/${ownerUid}/company/${businessId}`
                );

                const companySnap = await get(companyRef);

                if (companySnap.exists()) {
                    companies.push({
                        businessId,
                        ...companySnap.val(),
                        ownerUid
                    });
                }

            });

            await Promise.all(companyPromises);

            allBusinesses.push({
                ownerUid,
                companies
            });

        });

        await Promise.all(ownerPromises);

        // store structured shared businesses
        dispatch({
            type: actionType.ASSIGNERUSERBUSINESSES,
            payload: allBusinesses
        });

        // flatten companies and add isShared and ownerName
        const sharedCompaniesFlat = allBusinesses.flatMap(owner => {

            const ownerInfo = state?.ASSIGNERUSER?.find(u => u.ownerUid === owner.ownerUid);
            const ownerName = ownerInfo?.user?.name || ownerInfo?.user?.email || ownerInfo?.user?.contact
                ;
            console.log("ownerName", ownerInfo)
            return owner.companies.map(company => ({
                ...company,
                isShared: true,
                ownerName: ownerName
            }));
        });

        const existingBusinesses = state?.BUSINESSES || [];

        const allComps = [...existingBusinesses, ...sharedCompaniesFlat];

        // Deduplicate businesses based on companyId
        const mergedBusinesses = Array.from(
            new Map(allComps.map(biz => [biz.companyId || biz.id || biz.businessId, biz])).values()
        );

        dispatch({
            type: actionType.BUSINESSES,
            payload: mergedBusinesses
        });

        return allBusinesses;

    } catch (error) {

        console.error("Firebase Business Fetch Error:", error);
        return [];

    }
};

export default GetAssignerUserBusinessData;